import React from "react";
import { Link } from "react-router-dom";
import "./index.css";

export default class Notfound extends React.Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount(){
  }

  timeFun(){
  }

  render() {
    return (
      <div className="offlineBook">
        <div className="box">
          <img className="img"  src={require('../../../common/images/offlineBg.png')} />
          <Link to='/' className="go_btn">立即跳转</Link>
        </div>
      </div>
    );
  }
}
